export default {
  delete: {
    general: {
      color: '#f44336',
      backgroundColor: '#fff',
      textTransform: 'none',
    },
  },
};
